/**
 * Shared land-monitoring SEO description. Used by both `<Seo>` meta and the
 * WebPage JSON-LD node so search snippets and structured data cannot drift.
 * Boundr is paid-from-signup; keep this aligned with the JSON-LD Offer price.
 */
export const LAND_MONITORING_DESCRIPTION =
  'Boundr sends trained inspectors to your vacant plot with photo & video evidence. Encroachment alerts, 5-day reports. Starting at ₹1499 for NRI & remote landowners.';
